(() => {
  const ROOT = '[data-bridge-carousel]';
  const instances = new WeakMap();

  function build(root) {
    if (instances.has(root)) return;
    if (typeof window.Swiper === 'undefined') return;

    const container = root.querySelector('.swiper');
    if (!container) return;

    const slideCount = container.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    const perView = parseFloat(root.dataset.slidesPerView) || 1;
    const perViewMobile = parseFloat(root.dataset.slidesPerViewMobile) || perView;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const swiper = new window.Swiper(container, {
      slidesPerView: Math.min(perViewMobile, slideCount),
      spaceBetween: 12,
      speed: reduceMotion ? 0 : 400,
      a11y: { enabled: true },
      keyboard: { enabled: true, onlyInViewport: true },
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        581: { slidesPerView: Math.min(perView, slideCount) },
      },
      on: {
        slideChange: () => {
          root.dispatchEvent(new CustomEvent('bridge:slidechange', { bubbles: true }));
        },
      },
    });

    instances.set(root, swiper);
  }

  function destroy(root) {
    const swiper = instances.get(root);
    if (!swiper) return;
    swiper.destroy(true, true);
    instances.delete(root);
  }

  function apply(scope = document) {
    scope.querySelectorAll(ROOT).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(ROOT).forEach(destroy);
  });
})();
